(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-members-real-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (!root || root.dataset.rmrInit === '1') return;
    root.dataset.rmrInit = '1';

    // Autoplay every tile video (visible + duplicated) unless reduced motion.
    if (!reduce) {
      root.querySelectorAll('video').forEach(function (v) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    }

    // Play/pause toggle buttons (only rendered on the visible set).
    root.querySelectorAll('.real-members__play').forEach(function (btn) {
      var tile = btn.closest('.real-members__tile');
      var video = tile && tile.querySelector('video');
      if (!video) return;

      var sync = function () {
        var playing = !video.paused && !video.ended;
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      };

      btn.addEventListener('click', function () {
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  }

  function initAll() {
    document.querySelectorAll('.real-members').forEach(initSection);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // Theme editor: re-init when this section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.real-members');
    if (root) {
      root.dataset.rmrInit = '';
      initSection(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStw(root) {
    if (root.dataset.stwInit === '1') return;

    var layers = Array.prototype.slice.call(root.querySelectorAll('.stw__layer'));
    var n = layers.length;
    if (n === 0) return;

    // One shared background video for the whole section (section-level setting).
    var bgVideo = root.querySelector('.stw__stage-bg video');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var pinMobile = root.dataset.pinMobile === 'true';

    // Fallback: no pin (mobile w/o opt-in, reduced motion, or <2 slides).
    // Leave the natural stacked layout; all content already in the DOM.
    if (n < 2 || reduce || (isMobile && !pinMobile)) return;

    root.dataset.stwInit = '1';
    root.style.setProperty('--slides', n);
    root.classList.add('stw--js');

    var cue = root.querySelector('.stw__cue');
    var pp = root.querySelector('.stw__playpause');
    var live = root.querySelector('.stw__live');
    var current = -1;

    var revealVh = parseFloat(root.dataset.revealVh || '100');

    function updatePlayPause() {
      if (!pp) return;
      if (!bgVideo) { pp.hidden = true; return; }
      pp.hidden = false;
      var playing = !bgVideo.paused;
      pp.classList.toggle('is-playing', playing);
      pp.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    function setActive(i) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i === current) return;
      current = i;
      layers.forEach(function (l, j) {
        var on = j === i;
        l.classList.toggle('is-active', on);
        l.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      // Single shared video — it just keeps running across all slides.
      updatePlayPause();
      if (live) live.textContent = layers[i].getAttribute('data-name') || '';
    }

    if (pp) {
      pp.addEventListener('click', function () {
        if (!bgVideo) return;
        if (bgVideo.paused) { var p = bgVideo.play(); if (p && p.catch) p.catch(function () {}); }
        else { bgVideo.pause(); }
        updatePlayPause();
      });
    }

    // Autoplay the shared video once pinned mode is active.
    if (bgVideo) {
      var play = bgVideo.play();
      if (play && play.catch) play.catch(function () {});
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var rect = root.getBoundingClientRect();
        var scrolled = Math.max(0, -rect.top);        // px scrolled into the wrapper
        var revealPx = (revealVh / 100) * vh;

        // --- Phase 1: reveal (opening scale-up) ---
        // Pinned == the wrapper's top has reached (or passed) the viewport top.
        // Until then the sticky stage is still travelling up the screen and is
        // kept hidden by CSS.
        root.classList.toggle('is-pinned', rect.top <= 0);

        var revealProgress = revealPx > 0 ? Math.min(1, scrolled / revealPx) : 1;
        root.style.setProperty('--reveal-progress', revealProgress.toFixed(4));
        root.classList.toggle('is-revealing', revealProgress < 1);
        // The preceding section is intentionally left visible: the wrapper's
        // negative margin overlaps it, so the growing box reads as floating
        // over live content rather than over a flat backdrop.

        // --- Phase 2: crossfade (only advances once the reveal has completed) ---
        var cfScrolled = Math.max(0, scrolled - revealPx);
        var cfTotal = (root.offsetHeight - vh) - revealPx;   // == (n - 1) * vh
        var cfProgress = cfTotal > 0 ? Math.min(1, cfScrolled / cfTotal) : 0;
        var idx = Math.min(n - 1, Math.floor(cfProgress * n));
        setActive(idx);

        if (cue) {
          var fill = revealProgress < 1 ? revealProgress : ((cfProgress * n) - idx);
          cue.style.setProperty('--fill', Math.max(0, Math.min(1, fill)).toFixed(3));
          cue.classList.toggle('is-hidden', revealProgress >= 1 && idx === n - 1);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setActive(0);
    onScroll();
  }

  function initAll() { document.querySelectorAll('.stw').forEach(initStw); }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.stw');
    if (root) { root.dataset.stwInit = ''; root.classList.remove('stw--js'); initStw(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTesti(root) {
    if (!root || root.dataset.testiInit === '1') return;
    root.dataset.testiInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    var index = 0;
    var timer = null;
    var inView = true;
    var paused = false;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = Math.max(2, parseFloat(root.dataset.interval || '6')) * 1000;

    function show(i, focusTab) {
      i = (i + panels.length) % panels.length;
      index = i;
      tabs.forEach(function (t, j) {
        var sel = j === i;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
        t.classList.toggle('is-active', sel);
      });
      panels.forEach(function (p, j) {
        var sel = j === i;
        p.hidden = !sel;
        p.classList.toggle('is-active', sel);
      });
      if (focusTab && tabs[i]) tabs[i].focus();
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (!autoplay || panels.length < 2 || !inView || paused) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }
    function restart() { stop(); play(); }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); restart(); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); show(n, true); restart(); }
      });
    });

    var prevBtn = root.querySelector('.testi__nav--prev');
    var nextBtn = root.querySelector('.testi__nav--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); restart(); });

    // Pause on hover / focus.
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; play(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) { paused = false; play(); }
    });

    // Pause when out of viewport.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          if (inView) play(); else stop();
        });
      }, { threshold: 0.25 }).observe(root);
    }

    show(0);
    play();
  }

  function initAll() {
    document.querySelectorAll('.testi').forEach(initTesti);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  // Theme editor lifecycle.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.testi');
    if (root) { root.dataset.testiInit = ''; initTesti(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
